import type { OrientDirection } from '@src/slide/application/service/snap-line-service/interface/orient.interface';
import type { IFrame } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import type {
    IElementModelProps,
} from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/element-model-props.interface';

/**
 * 参照元素的来源
 */
export enum RefSourceType {
    ELEMENT = 'element',    // 页面元素
    SLIDE  = 'slide',       // Slide页面本身
}

export interface IRefElement {
    ele: { props: IElementModelProps };
    source: RefSourceType;
    outerFrameOnSlide: IFrame;
}

export interface IRefFrame extends IFrame {
    right: number;
    bottom: number
}

export type MarginRefGroup = [IRefElement, IRefElement][];
export type MarginRefGroupWithOrientDirection = Record<OrientDirection, IRefElement[]>;
export type SymmetryRefGroup = IRefElement[];
